import {
  apiClient,
  type DriverUserListExEntity,
  type PageEntity
} from '@/libs/api'
import { type DriverUsersWithPaginationRequestQuery } from '@/libs/api/types'

export type FetchDriverUsersWithPaginationQuery = {
  tenantKey: string
  query?: DriverUsersWithPaginationRequestQuery
}

export type FetchDriverUsersWithPaginationResponse = {
  data: DriverUserListExEntity[]
  pagination: PageEntity | null
}

export const fetchDriverUsersWithPagination = async (
  { tenantKey, query }: FetchDriverUsersWithPaginationQuery,
  signal?: AbortSignal
): Promise<FetchDriverUsersWithPaginationResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .driver_users.list.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
